var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWineIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.22573 10.3311C7.24747 10.4959 7.24747 10.6629 7.22573 10.8277C7.26804 11.1023 7.24531 11.383 7.15938 11.6472C7.07344 11.9114 6.92671 12.1517 6.73099 12.3487C6.53527 12.5458 6.29604 12.694 6.03258 12.7816C5.76911 12.8692 5.48878 12.8936 5.21417 12.8529C4.93955 12.8121 4.67834 12.7074 4.45156 12.5472C4.22478 12.3869 4.03878 12.1756 3.90855 11.9303C3.77832 11.6849 3.7075 11.4123 3.70179 11.1346C3.69608 10.8568 3.75565 10.5816 3.87569 10.3311",
    stroke: "#333333",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.47553 7.79395C2.34764 8.06261 2.28935 8.35915 2.30601 8.65627C2.32267 8.95339 2.41376 9.24155 2.57088 9.4942C2.728 9.74686 2.94611 9.95588 3.20512 10.1021C3.46414 10.2482 3.75573 10.3268 4.05306 10.3306C4.35295 10.3264 4.64686 10.246 4.90726 10.0971C5.16766 9.94818 5.38605 9.73556 5.54197 9.47916",
    stroke: "#333333",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.17705 7.1558C3.95128 7.44931 3.63936 7.66474 3.28506 7.77185C2.93075 7.87895 2.55183 7.87237 2.20145 7.75303C1.85106 7.63369 1.5468 7.40758 1.33133 7.10641C1.11586 6.80524 1 6.44412 1 6.07371C1 5.7033 1.11586 5.34218 1.33133 5.04101C1.5468 4.73984 1.85106 4.51373 2.20145 4.39439C2.55183 4.27505 2.93075 4.26848 3.28506 4.37559C3.63936 4.4827 3.95128 4.69811 4.17705 4.99162",
    stroke: "#333333",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.64368 7.79395C8.78579 8.06429 8.85574 8.36678 8.84674 8.67213C8.83775 8.97748 8.75012 9.27532 8.59233 9.53682C8.43455 9.79832 8.21197 10.0146 7.94614 10.1648C7.68031 10.3149 7.38024 10.3938 7.075 10.3938C6.76976 10.3938 6.4697 10.3149 6.20387 10.1648C5.93804 10.0146 5.71545 9.79832 5.55767 9.53682C5.39989 9.27532 5.31225 8.97748 5.30326 8.67213C5.29427 8.36678 5.36421 8.06429 5.50633 7.79395",
    stroke: "#333333",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.87134 7.15539C7.03628 7.35888 7.24421 7.52327 7.4802 7.63676C7.71618 7.75024 7.97436 7.81 8.23617 7.81174C8.54308 7.82524 8.84823 7.75869 9.12169 7.6186C9.39515 7.4785 9.62754 7.26968 9.79606 7.01262C9.96458 6.75555 10.0634 6.45908 10.083 6.15226C10.1025 5.84543 10.042 5.53878 9.9074 5.2624C9.77282 4.98603 9.56877 4.7494 9.31527 4.57574C9.06177 4.40207 8.76752 4.29732 8.46138 4.27177C8.15523 4.24621 7.84771 4.30071 7.56896 4.42995C7.29021 4.55919 7.04981 4.75871 6.87134 5.00896",
    stroke: "#333333",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.80493 6.07372C3.80493 6.42456 3.90889 6.76753 4.10365 7.05925C4.29842 7.35097 4.57525 7.57834 4.89913 7.7126C5.22302 7.84686 5.57941 7.88199 5.92324 7.81355C6.26708 7.7451 6.58291 7.57615 6.8308 7.32806C7.07869 7.07998 7.2475 6.76389 7.3159 6.41979C7.38429 6.07568 7.34919 5.71901 7.21503 5.39487C7.08087 5.07073 6.85369 4.79369 6.5622 4.59877C6.27071 4.40385 5.92801 4.2998 5.57744 4.2998C5.10734 4.2998 4.6565 4.4867 4.32409 4.81937C3.99168 5.15204 3.80493 5.60325 3.80493 6.07372Z",
    stroke: "#333333",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.54199 4.31763C5.54818 3.68909 5.78731 3.08524 6.21305 2.62312C6.63878 2.161 7.22079 1.87352 7.84626 1.81641",
    stroke: "#333333",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.31138 4.31722C5.40485 3.64771 5.28358 2.96578 4.96505 2.36965C4.64651 1.77352 4.14715 1.29395 3.53887 1C3.35342 1.67491 3.43391 2.39533 3.76373 3.01258C4.09355 3.62983 4.64754 4.09683 5.31138 4.31722Z",
    stroke: "#333333",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWineIcon);
export default __webpack_public_path__ + "static/media/wineIcon.fc430794f8a88e2554d0b37471e10850.svg";
export { ForwardRef as ReactComponent };